import React from 'react';
import { partNumber as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const PartNumber = (props) => {
  const { parameters } = props
  const name = 'part_number';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <TextComponent
      label={props.label}
      name={name}
      inputId={props.inputId}
      value={value || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip || tooltip}
      ignoreOnQuote
      groupName={props.groupName} >
      {props.children}</TextComponent>
  );
};

PartNumber.defaultProps = {
  required: true,
  inputId: 'part-number',
  label: 'Part<br class="d-none d-lg-block d-xl-none" /> Number',
};

export default PartNumber;
